// extracted by mini-css-extract-plugin
export var actions = "_qf-4";
export var item = "_qf-1";
export var price = "_qf-3";
export var quantity = "_qf-2";
export var table = "_qf-0";